/**
 * @package FlorenceEGI — EGI — WOW Cinematic Home v2.0
 * @author Padmin D. Curtis (AI Partner OS3.0) for Fabio Cherici
 * @version 2.0.0 (FlorenceEGI — EGI)
 * @date 2026-04-28
 * @purpose Vanilla TS scroll enhancer for 3-Act narrative homepage.
 *          - Navbar: transparent over hero, solid on scroll
 *          - Reveal animations: IntersectionObserver fade-in
 *          - Burger menu toggle
 *          Target: <4KB brotli. Zero framework. Zero render-blocking.
 */

function $(sel: string, ctx: ParentNode = document): HTMLElement | null {
  return ctx.querySelector(sel);
}

function initNavbarScroll(): void {
  const nav = $('.wow-nav');
  if (!nav) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      nav.classList.toggle('is-scrolled', !entry.isIntersecting);
    },
    { threshold: 0.1 }
  );

  const hero = $('.wow-hero');
  if (hero) {
    observer.observe(hero);
  } else {
    nav.classList.add('is-scrolled');
  }
}

function initRevealAnimations(): void {
  const elements = document.querySelectorAll<HTMLElement>('[data-wow-reveal]');
  if (!elements.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  elements.forEach((el) => observer.observe(el));
}

function initBurgerMenu(): void {
  const burger = $('[data-wow-burger]');
  const menu = $('[data-wow-mobile-menu]') as HTMLElement | null;
  if (!burger || !menu) return;

  burger.addEventListener('click', () => {
    const open = !menu.hidden;
    menu.hidden = open;
    burger.setAttribute('aria-expanded', String(!open));
  });

  menu.addEventListener('click', (e: Event) => {
    if ((e.target as HTMLElement).tagName === 'A') {
      menu.hidden = true;
      burger.setAttribute('aria-expanded', 'false');
    }
  });
}

function init(): void {
  initNavbarScroll();
  initRevealAnimations();
  initBurgerMenu();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
